import { supabase } from './supabase';
import { useInstagramStore } from '../stores/useInstagramStore';

// 방문자 분석은 '내 인스타그램 계정 연결'이 먼저다.
// 대표 11/3 터미널: "절대적으로 자신의 아이디를 먼저 연동하게 해야 되잖아" · "그럼 계정 연결도 확인하게 하면 되지 않아?"
// 11/3 확인(클래리티 녹화·DB): 계정을 연결하지 않은 손님이 알림톡 → 로그인 → 방문자 분석 화면에서 자기 아이디를 넣고 분석
// → 1크레딧 결제 → 같은 아이디를 '내 계정'으로 연결 → 환불 요청. 최근 5일 1크레딧 첫 결제 환불 41명 중 22명이 이 모양이었다.
// 예전 검사는 이미 연결된 계정이 있을 때만 '자기 계정 금지'를 비교해서, 연결 전에는 아무것도 막지 못했다.
//
// 분석 대상 프로필을 불러오는 순간(visitor-analysis-target) 분석 기록이 생기므로, 이 확인은 그 호출보다 먼저 한다.
// 화면 상태(connectedProfile)는 늦게 채워질 수 있어서, 비어 있거나 다른 회원 것이면 저장된 연결 계정 표를 직접 한 번 본다.

// 안내 문장은 대표 11/3 원문을 따른다: "먼저 인스타그램을 다시 등록해 주세요 … 등록을 해주셔야 됩니다.
// 그래야 최신 정보를 기반으로 저희가 만족스러운 결과를 만들어 드릴 수 있다"
export const CONNECT_FIRST_TITLE = '먼저 내 인스타그램 계정을 등록해 주셔야 합니다.';
export const CONNECT_FIRST_BODY = '그래야 최신 정보를 바탕으로 만족스러운 결과를 만들어 드릴 수 있어요.';
export const CONNECT_FIRST_MESSAGE = `${CONNECT_FIRST_TITLE} ${CONNECT_FIRST_BODY}`;
/** 분석 전에 계정 등록이 필요해서 보낼 때의 주소 — 등록 화면 맨 위에 같은 안내를 띄운다 */
export const CONNECT_FIRST_PATH = '/connected-account?need=analysis';
export const SELF_ANALYSIS_MESSAGE = '자신의 Instagram 계정은 분석할 수 없습니다. 다른 사람의 계정을 입력해주세요.';

// 관리자 미리보기 — 대표 11/3 "그거 내가 직접 확인할 수 있게 보여줘 … 실제 핸드폰으로 확인하게 해줘".
// 대표 계정은 인스타가 이미 등록돼 있어 '등록하지 않은 손님 화면'이 안 보이므로, 주소에 ?preview=unregistered 가 있고
// 대표 번호로 로그인했을 때만 그 화면을 그대로 보여 준다(등록 화면은 눌러도 아무것도 안 바뀌게 잠근다). 손님에게는 아무 효과 없음.
const ADMIN_PHONE = '821026703079';
export const UNREGISTERED_PREVIEW_SUFFIX = '&preview=unregistered';
export const isUnregisteredPreview = (search: URLSearchParams, phone?: string | null): boolean =>
    search.get('preview') === 'unregistered' && (phone || '').replace(/^\+/, '') === ADMIN_PHONE;

const clean = (username: string): string => username.trim().replace('@', '').toLowerCase();

/** 이 회원이 연결한 내 인스타 아이디(소문자). 연결한 계정이 없으면 null. */
export async function getMyConnectedUsername(userId: string): Promise<string | null> {
    const { connectedProfile } = useInstagramStore.getState();
    if (connectedProfile?.username && (!connectedProfile.user_id || connectedProfile.user_id === userId)) {
        return clean(connectedProfile.username);
    }
    const { data, error } = await supabase
        .from('saved_instagram_accounts')
        .select('username')
        .eq('user_id', userId)
        .order('updated_at', { ascending: false })
        .limit(1);
    if (error) {
        console.warn('[내 계정 확인] 연결 계정 조회 실패:', error.message);
        return null;
    }
    const username = data?.[0]?.username;
    return username ? clean(String(username)) : null;
}
